export const EDICOLA_DELIVERY_TYPE = 'Edicola';
export const POSTA_DELIVERY_TYPE = 'Posta';
export const NO_CONSEGNA_DELIVERY_TYPE = 'noConsegna';

export const MAXIMUN_PRICE_KEY = "maximum_price";

export const deliveryTypes = [POSTA_DELIVERY_TYPE, EDICOLA_DELIVERY_TYPE];

export const DELIVERY_TYPES_MAP = {
  [POSTA_DELIVERY_TYPE] : deliveryTypes[0],
  [EDICOLA_DELIVERY_TYPE] : deliveryTypes[1]
}
export const DELIVERY_TYPES_OPTION_MAP = {
  "1": deliveryTypes[0],
  "2" : deliveryTypes[1]
}

export const getXMLFieldsArray = (xmlBlock, field: string) => {
  try { return xmlBlock[0].children.filter(el => el.name == field); }
  catch (e) { return xmlBlock.children.filter(el => el.name == field); }
}
export const getXMLField = (xmlBlock, field: string) => {
  if (field === 'src' || field === 'alt') {
    const regex = new RegExp(`<${field}>(.*?)<\/${field}>`);
    const match = xmlBlock.match(regex);
    if (match) {
      const data = match[1];
      return data;
    } else {
      return ''
    }
  }
  try {
    const fieldXML = xmlBlock[0].children.find(el => el.name === field);
    return fieldXML ? getXMLFieldContent(fieldXML) : null;
  } catch (er) {
    const fieldXML = xmlBlock && xmlBlock.children ? (xmlBlock.children.find(el => el.name === field)) : null;
    if (!fieldXML) return null;
    return getXMLFieldContent(fieldXML);
  }
};

const getXMLFieldContent = (fieldXML) => {
  if (!fieldXML || !fieldXML.children) return '';

  return fieldXML.children.map(child => {
    if (child.type === 'text') {
      return child.data;
    } else if (child.type === 'tag') {
      return `<${child.name}>${getXMLFieldContent(child)}</${child.name}>`;
    }
    return '';
  }).join('');
};


/**
 * Otput always dd.mm.yyyy
 */
export const formatDate = (date, inputFormat?: string, outputSeparator?: string) => {
  const DATE_SEPARATOR = outputSeparator ?? '.';
  if (inputFormat) {
    const dayIndex = inputFormat.indexOf('DD');
    const monthIndex = inputFormat.indexOf('MM');
    const yearIndex = inputFormat.indexOf('YYYY');
    return `${date.substring(dayIndex, dayIndex + 2)}${DATE_SEPARATOR}${date.substring(monthIndex, monthIndex + 2)}${DATE_SEPARATOR}${date.substring(yearIndex, yearIndex + 4)}`;
  } else {
    const d = new Date(date);
    return `${d.getDate()}${DATE_SEPARATOR}${d.getMonth() + 1}${DATE_SEPARATOR}${d.getFullYear()}`;
  }
};


export const elementIsInViewport = (element) => {
  const rect = element.getBoundingClientRect()
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  )
}


export const setElementWidthByCardsContainer = (el: HTMLElement, mauto?: boolean) => {
  if (window.innerWidth < 1024) {
    el.style.marginLeft = mauto ? 'auto' : '0px';
    return;
  };
  setTimeout(() => {
    const carousel = document.querySelector('#purchase-options .carousel-container');
    if (carousel) {
      const computedStyle = getComputedStyle(carousel);
      el.style.width = (carousel.clientWidth - (parseFloat(computedStyle.paddingLeft) + parseFloat(computedStyle.paddingRight))) + 'px'
      el.classList.remove('mx-auto');
      el.style.marginLeft = computedStyle.paddingLeft
    } else {
      /* const fitContents = document.querySelector('#purchase-options .w-fit.contents div') as HTMLElement;
       fitContents && (pb.style.width = fitContents.offsetWidth+'px')*/
      const cards = document.querySelectorAll('#purchase-options .solepro-option-card');
      try {
        el.style.width = (cards[cards.length - 1].getBoundingClientRect().right - cards[0].getBoundingClientRect().left) + 'px';
      } catch (e) {
        /** Security fallback */
        el.style.width = '768px';

      }
    }
  }, 200)
}


export function loadScript(script, id, callback) {
    const aScript: any = document.createElement('script');
    if (id) {
        const scriptid = document.getElementById(id);
        if (scriptid) {
            document.head.removeChild(scriptid);
        }
        aScript.id = id;
    }
    if (callback) {
        aScript.onload = () => {
            const state = aScript.readyState;
            if (!callback.done && (!state || /loaded|complete/.test(state))) {
                callback.done = true;
                callback();
            }
        };
        aScript.onreadystatechange = aScript.onload;
    }

    aScript.src = script;
    aScript.async = true;
    aScript.setAttribute('async', '');
    aScript.setAttribute('defer', '');
    aScript.type = 'text/javascript';
    document.head.appendChild(aScript);
}


export const copyCode = async (textToCopy, callback, failCallback) => {

  // Esegui il codice solo sul client
  if (process.client) {
    try {
      // Verifica che l'API navigator.clipboard esista
      if (navigator.clipboard) {
        await navigator.clipboard.writeText(textToCopy);
        console.log('Testo copiato con successo!');
        callback && callback();
      } else {
        // Fallback per browser meno recenti o contesti non sicuri
        console.warn('API Clipboard non supportata. Eseguo il fallback.');
        const textArea = document.createElement("textarea");
        textArea.value = textToCopy;
        textArea.style.position = 'fixed'; // Rendi il campo invisibile
        textArea.style.top = '0';
        textArea.style.left = '0';
        textArea.style.width = '2em';
        textArea.style.height = '2em';
        textArea.style.padding = '0';
        textArea.style.border = 'none';
        textArea.style.outline = 'none';
        textArea.style.boxShadow = 'none';
        textArea.style.background = 'transparent';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
        console.log('Testo copiato con successo (fallback)!');
        callback && callback();
      }
    } catch (err) {
      console.error('Impossibile copiare il testo:', err);
      failCallback && failCallback();
    }
  }
}

export const manageScroll = evt => {
  evt.preventDefault();
  try {
    const id = evt.currentTarget.href.split('#')[1]
    const rect = document.getElementById(id).getBoundingClientRect();
    const y = rect.top + window.scrollY - 140;
    window.scrollTo(0, y)
    
  } catch (e) {
    console.error('manageScroll erore', e)
  }
}